import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-services',
  templateUrl: './list-services.component.html',
  styleUrls: ['./list-services.component.css']
})
export class ListServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
